const InvoiceList = () => {
  return (
    <>
      <h1>asdfasd</h1>
    </>
  );
};

export default InvoiceList;